import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import actions from 'actions'
import SettingsContainer from 'containers/SettingsContainer/SettingsContainer'
import PlayerContainer from 'containers/PlayerContainer/PlayerContainer'
import TimelineContainer from 'containers/TimelineContainer/TimelineContainer'
import MetaEditContainer from 'containers/MetaEditContainer/MetaEditContainer'
import Notification from 'components/Notification/Notification'
import { Container, Grid } from 'semantic-ui-react'
import css from './MediaEditorContainer.module.sass'

class MediaEditorContainer extends Component {
  render () {
    const { mediaUrl } = this.props.settings.mediaParams

    return (
      <Container fluid>
        { !mediaUrl &&
          <SettingsContainer />
        }
        { mediaUrl &&
          <Container fluid>
            <Grid divided>
              <Grid.Row>
                <Grid.Column width='6'>
                  <PlayerContainer />
                </Grid.Column>
                <Grid.Column className={css.metaCol} width='10'>
                  <MetaEditContainer />
                </Grid.Column>
              </Grid.Row>
            </Grid>
            <TimelineContainer />
          </Container>
        }
        <Notification
          notificationStatus={this.props.media.notificationStatus}
          setNotificationStatus={this.props.setNotificationStatus}
        />
      </Container>
    )
  }
}

const {
  object,
  func
} = PropTypes

MediaEditorContainer.propTypes = {
  settings: object.isRequired,
  media: object.isRequired,
  setNotificationStatus: func.isRequired
}

export default connect((state) => {
  return {
    media: state.media,
    settings: state.settings
  }
}, {
  setNotificationStatus: actions.media.setNotificationStatus
})(MediaEditorContainer)



// WEBPACK FOOTER //
// ./src/containers/MediaEditorContainer/MediaEditorContainer.js